import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

export const propertyRoutes: RouteRecordRaw[] = [
  {
    path: routes.PROPERTY_DETAIL,
    name: 'PROPERTY_DETAIL',
    component: () => import('./PropertyDetailPage.vue'),
    meta: { requiresAuth: true },
  },
]
